var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ReturnShippingLabelAPI } from '../api/returns';
import { TagPrintReturnLabelBrowserError, TagShippingLabelButtonSubmission, } from './analytics-tagging';
import { isSsr } from './general';
import { getAPIErrorData } from './api-helpers';
export var openNewWindow = function (content) {
    var newWindow;
    if (!isSsr) {
        newWindow = window.open('', '_blank', 'top=0,left=0,height=750px,width=auto,scrollbars=yes,resizable=yes');
    }
    if (newWindow) {
        newWindow.document.open();
        newWindow.document.write(content);
        return newWindow;
    }
    return null;
};
export var createHtmlContent = function (conversionSrcArray, orderId) { return "\n  <!DOCTYPE html PUBLIC>\n  <html>\n    <head>\n      <title>Return Label | Order #".concat(orderId, "</title>\n      <style>\n      @page {\n        size: landscape;\n      }\n      </style>\n    </head>\n    <body style='text-align:center'>\n      <div id='imgDiv' style='display:block'>\n        ").concat(conversionSrcArray
    .map(function (conversionSrc, index) {
    return "<img src='".concat(conversionSrc, "' alt='Label ").concat(index + 1, "' /><br />").concat(index !== conversionSrcArray.length - 1
        ? '<div style="page-break-after: always;"></div>'
        : '');
})
    .join(''), "\n      </div>\n      <script>\n        const printLabel = () => {\n          window.print();\n        };\n\n        // Print the labels after a delay to allow the images to load\n        setTimeout(printLabel, 1000);\n      </script>\n    </body>\n  </html>\n"); };
export var getErrorBySSRCode = function (error) {
    switch (error.code) {
        case 'SSR_UPSPRNTLBL_ERR_1003':
            // Non UPS Tracking Number Error
            return {
                type: 'TEMPORARY',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1012':
            // Label Not Found Error
            return {
                type: 'TRYAGAIN',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1013':
            // Not Printable Error. Now switched to pickup
            return {
                type: 'SWITCHEDTOPICKUP',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1014':
            // Label Reuse Error
            return {
                type: 'USED',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1015':
            // Expired Label Error
            return {
                type: 'EXPIRED',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1016':
            // Invalid Label Error (switched from dropoff to pickup)
            return {
                type: 'SWITCHEDTOPICKUP',
                retryable: error.retryable,
            };
        case 'SSR_UPSPRNTLBL_ERR_1017':
            // Missing Tracking ID Error
            return {
                type: 'TEMPORARY',
                retryable: error.retryable,
            };
        default:
            // Unknown Error
            return {
                type: 'UNKNOWN',
                retryable: error.retryable,
            };
    }
};
export var createLabelFromTrackingDetails = function (trackingDetails, orderId) {
    var base64decode = 'data:image/png;base64,';
    var conversionSrcArray = trackingDetails.map(function (tracking) { return base64decode + tracking.shippingLabel; });
    return createHtmlContent(conversionSrcArray, orderId);
};
var createLabelRequest = function (params) {
    var emailId = params.emailId, orderId = params.orderId, isMilitaryExchangeGuest = params.isMilitaryExchangeGuest, orderDetailsV2 = params.orderDetailsV2, returnTrackingNumbers = params.returnTrackingNumbers;
    return {
        emailId: emailId,
        orderId: orderId,
        isGuest: isMilitaryExchangeGuest,
        net: (orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.net) || '',
        trackingNumbers: returnTrackingNumbers,
        PrintReturnShippingLabelRequest: {
            EmailId: emailId,
            OrderId: orderId,
            TrackingNumbers: returnTrackingNumbers,
        },
    };
};
var handleLabelResponse = function (response, orderId) {
    var _a, _b, _c, _d;
    var printLabelResponse = ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.printReturnShippingLabelService) === null || _b === void 0 ? void 0 : _b.printReturnLabelResponse) ||
        ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.PrintReturnShippingLabelService) === null || _d === void 0 ? void 0 : _d.PrintReturnLabelResponse);
    if (!printLabelResponse) {
        throw new Error('No label found');
    }
    var base64decode = 'data:image/png;base64,';
    var conversionSrcArray = printLabelResponse.map(function (item) { return base64decode + (item.labelGraphicImage || item.LabelGraphicImage); });
    return createHtmlContent(conversionSrcArray, orderId);
};
var handleLabelError = function (error, setAPIError) {
    var errorData = getAPIErrorData(error);
    if (errorData) {
        var errorInfo = getErrorBySSRCode(errorData);
        TagPrintReturnLabelBrowserError(errorInfo.type, error);
        setAPIError(errorInfo);
        return;
    }
    TagPrintReturnLabelBrowserError('TRYAGAIN');
    setAPIError({ type: 'TRYAGAIN', retryable: true });
};
var handleNativeAppLabel = function (params, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var setRetryAvailable, content, base64Html;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                setRetryAvailable = (callbacks || {}).setRetryAvailable;
                return [4 /*yield*/, fetchLabel(params, callbacks)];
            case 1:
                content = _b.sent();
                if (content) {
                    base64Html = btoa(content);
                    (_a = window === null || window === void 0 ? void 0 : window.LIFE_CYCLE_EVENT_BUS) === null || _a === void 0 ? void 0 : _a.trigger('NATIVE_APP.PRINT_BASE64', {
                        base64HtmlData: base64Html,
                    });
                    setRetryAvailable === null || setRetryAvailable === void 0 ? void 0 : setRetryAvailable(true);
                }
                return [2 /*return*/];
        }
    });
}); };
var handleNewTabFirst = function (params, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, setRetryAvailable, setAPIError, newWindow, content;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = callbacks || {}, setRetryAvailable = _a.setRetryAvailable, setAPIError = _a.setAPIError;
                newWindow = window.open('', '_blank', 'top=0,left=0,height=750px,width=auto,scrollbars=yes,resizable=yes');
                if (!newWindow) {
                    TagPrintReturnLabelBrowserError('TRYAGAIN');
                    setAPIError === null || setAPIError === void 0 ? void 0 : setAPIError({ type: 'TRYAGAIN', retryable: true });
                    return [2 /*return*/];
                }
                return [4 /*yield*/, fetchLabel(params, callbacks)];
            case 1:
                content = _b.sent();
                if (!content) {
                    newWindow.close();
                    return [2 /*return*/];
                }
                newWindow.document.write(content);
                setRetryAvailable === null || setRetryAvailable === void 0 ? void 0 : setRetryAvailable(true);
                return [2 /*return*/];
        }
    });
}); };
var fetchLabel = function (params, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var trackingDetails, orderId, _a, setIsLoading, setAPIError, request, response, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                trackingDetails = params.trackingDetails, orderId = params.orderId;
                _a = callbacks || {}, setIsLoading = _a.setIsLoading, setAPIError = _a.setAPIError;
                // if we have shipping label from Create Return, return that.
                if (trackingDetails) {
                    return [2 /*return*/, createLabelFromTrackingDetails(trackingDetails, orderId)];
                }
                setIsLoading === null || setIsLoading === void 0 ? void 0 : setIsLoading(true);
                setAPIError === null || setAPIError === void 0 ? void 0 : setAPIError(undefined);
                request = createLabelRequest(params);
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, ReturnShippingLabelAPI(request)];
            case 2:
                response = _b.sent();
                return [2 /*return*/, handleLabelResponse(response, orderId)];
            case 3:
                error_1 = _b.sent();
                if (setAPIError)
                    handleLabelError(error_1, setAPIError);
                return [2 /*return*/, undefined];
            case 4:
                setIsLoading === null || setIsLoading === void 0 ? void 0 : setIsLoading(false);
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var openReturnLabelInNewTab = function (params, isNativeApp, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, setRetryAvailable, setAPIError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = callbacks || {}, setRetryAvailable = _a.setRetryAvailable, setAPIError = _a.setAPIError;
                setRetryAvailable === null || setRetryAvailable === void 0 ? void 0 : setRetryAvailable(false);
                setAPIError === null || setAPIError === void 0 ? void 0 : setAPIError(undefined);
                if (!isNativeApp) return [3 /*break*/, 2];
                return [4 /*yield*/, handleNativeAppLabel(params, callbacks)];
            case 1:
                _b.sent();
                return [2 /*return*/];
            case 2: return [4 /*yield*/, handleNewTabFirst(params, callbacks)];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); };
// Begins the process of printing a shipping label alongside analytics tagging
export var executePrintShippingLabel = function (params, isNativeApp, militaryExchange, callbacks) {
    var emailId = params.emailId, orderId = params.orderId;
    TagShippingLabelButtonSubmission(militaryExchange);
    if (emailId && orderId) {
        openReturnLabelInNewTab(params, isNativeApp, callbacks);
    }
};
